import { createRootRoute, Link, Outlet, useMatchRoute, useLocation  } from '@tanstack/react-router'
import Logo from "../layout/Icon.tsx"
import {useState, useEffect} from "react";
import SideNavbar from "../layout/SideNavbar";
import LogOutButton from "../layout/LogOutButton.js";
import Footer from "../layout/Footer"

export const Route = createRootRoute({
    component: () =>{
        const matchRoute = useMatchRoute()
        const location = useLocation();
        const [currentPath, setCurrentPath] = useState(location.pathname);
        const [trimmedMenu, setTrimmedMenu] = useState<boolean>(false);

        useEffect(() => {
            setCurrentPath(location.pathname);
        }, [location.pathname]);

        const updateMenu = () => {
            return window.innerWidth < 760 ?
                setTrimmedMenu(true) :
                setTrimmedMenu(false)
        }

        useEffect(() => {
            updateMenu();
            window.addEventListener("resize", updateMenu);
            return () => window.removeEventListener("resize", updateMenu);
        }, [])

        const isLoginPage = matchRoute({ to: "/login"})
        const isRegisterPage = matchRoute({to: "/register"})
        const isAboutPage = matchRoute({ to: "/about"})
        const isVacanciesPage = matchRoute({ to: "/vacancies"})
        const isAccountId = matchRoute({ to: "/account/$id"})
        const isCallbackRole = matchRoute({ to: "/account/callback/$userType"})
        const isRoleChoice = matchRoute({ to: "/account-role-choice"})
        const isAccountPage = matchRoute({ to: "/user"})
        const isBlogPostPage = matchRoute({ to: "/post/$id"})
        const isBlogEditForm = matchRoute({ to: "/admin/blog/edit"})
        const isReportModal = matchRoute({to: "/report/$id"})
        const isReportEditForm = matchRoute({ to: "/admin/report/edit"})
        const isPolicyPage = matchRoute({to: "/policy-page"})
        const resumeRoutes = new Set([
            "/create-resume",
            "/resume/edit",
            "/resume/view",
            "/resume/view/file",
            "/resume/upload"
        ]);

        const vacancyRoutes = new Set([
            "/create-vacancy",
            "/vacancy/edit",
        ]);
        const isApplyPage = matchRoute({ to: "/vacancy/apply/$id"})
        const isAdminLogin = matchRoute({ to: "/admin/global-login"})
        const isCurrAdminLogin = matchRoute({ to: "/admin/current-admin-login"})
        const isAdminPanel = matchRoute({ to: "/admin/home-page"})

        const viewVacancy = matchRoute({to: "/vacancy/view/$id"});
        const isResumeRoute = [...resumeRoutes].some(route => currentPath.startsWith(route));
        const isVacancyRoute = [...vacancyRoutes].some(route => currentPath.startsWith(route));

        return (
            <div key={currentPath}>
                { trimmedMenu ?
                    (<div className={`absolute top-0 left-0 w-full h-15 z-10
                    `}>
                        <SideNavbar />
                    </div>) :
                    (
                        <>
                            <div
                                className={`absolute top-0 left-0 w-full px-10 py-6 flex text-white z-10 justify-between
                            ${isRoleChoice || isAccountId || isCallbackRole ? "invisible" : "visible"}
                            ${isAccountPage && "backdrop-blur-sm"}
                        `}>
                                <div className="flex gap-8">
                                    <Link to="/" className="">
                                        <Logo/>
                                    </Link>
                                    <div className="hover:inset-shadow-sm rounded-lg p-3 text-white">
                                        <Link to="/" className={`[&.active]:font-bold 
                                            ${isLoginPage || isRegisterPage || isAboutPage || isVacanciesPage || isVacancyRoute || isResumeRoute || isReportEditForm || isReportModal ? "hover:text-gray-900" : "hover:text-chromatic"}
                                            ${isAccountPage || isBlogPostPage || isAdminLogin || isCurrAdminLogin || isAdminPanel || isApplyPage || viewVacancy || isBlogEditForm || isReportEditForm || isPolicyPage ? "text-gray-900" : "text-white"}
                                        `}>
                                            На Головну
                                        </Link>
                                    </div>

                                    {["about", "blog", "vacancies", "contacts"].map((path) => (
                                        <div key={path} className="hover:inset-shadow-sm rounded-lg p-3 text-white">
                                            <Link
                                                to = {`/${path as "about" | "blog" | "vacancies" | "contacts"}`}
                                                className={`[&.active]:font-bold 
                                            ${isLoginPage || isRegisterPage || isAboutPage || isVacanciesPage || isReportEditForm || isVacancyRoute || isResumeRoute || isReportModal ? "hover:text-gray-900" : "hover:text-chromatic"}
                                            ${isAccountPage || isBlogPostPage || isAdminLogin || isCurrAdminLogin || isAdminPanel || isApplyPage || viewVacancy || isBlogEditForm || isReportEditForm || isPolicyPage ? "text-gray-900" : "text-white"}
                                        `}
                                            >
                                                {path === "about" ? "Про нас" :
                                                    path === "blog" ? "Новини" :
                                                        path === "vacancies" ? "Вакансії" :
                                                            "Контакти"
                                                }
                                            </Link>
                                        </div>
                                    ))}
                                </div>

                                <LogOutButton />
                            </div>
                            <div>
                                <Outlet/>
                            </div>
                            <Footer />
                        </>
                )}
            </div>
        )
    }
})